import React from 'react';
import Select from 'react-select'

const SearchableSelect = (props) => {
    const {
        name,
        value,
        onChange,
        options         = [],
        placeholder     = null,
        required        = false,
        disabled        = false,
        menuPlacement   = 'auto',
        isMulti         = false,
        error           = null
    } = props;

    const extractValue = () => {
        if (!value || value === "" || !options || options.length <= 0) {
            return "";
        }

        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return options[i];
            }
        }

        return "";
    }

    return (
        <Select
            id={name}
            name={name}
            value={isMulti ? value : extractValue()}
            className={!error ? "searchable-select shadow-none" : "searchable-select shadow-none is-invalid"}
            required={required}
            isDisabled={disabled}
            menuPlacement={menuPlacement}
            onChange={(item) => onChange(isMulti ? item : item.value)}
            options={options}
            isMulti={isMulti}
            placeholder={placeholder}
            isSearchable={true}
        />
    );
}

export default SearchableSelect;
